// Shows a transient Bootstrap-styled error toast, reusing the same
// #pdf-export-toasts container used by pass export status toasts.
export function showErrorToast(message) {
  const toast = document.createElement("div")
  toast.className = "toast show text-bg-danger border-0 mb-2 shadow"
  toast.setAttribute("role", "alert")
  toast.setAttribute("aria-live", "assertive")
  toast.setAttribute("aria-atomic", "true")

  const body = document.createElement("div")
  body.className = "toast-body d-flex align-items-center gap-2"

  const icon = document.createElement("span")
  icon.className = "bi bi-exclamation-triangle-fill"

  const text = document.createElement("span")
  text.textContent = message

  body.appendChild(icon)
  body.appendChild(text)
  toast.appendChild(body)

  const container = document.getElementById("pdf-export-toasts") || document.body
  container.appendChild(toast)

  setTimeout(() => toast.remove(), 5000)

  return toast
}
